export default __webpack_public_path__ + "images/butelka_active.png";